import '../pages.scss';
import Snackbar from "../../components/snackbar.mjs";
import TopNavBar from '../../components/topNavBar.mjs';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";


const ContactPage = () => {
    const [bodyText, setBodyText] = useState("");
    const [categoryType, setCategoryType] = useState("");

    const navigate = useNavigate();

    const keygenID = sessionStorage.getItem('keygenID');
	const userToken = sessionStorage.getItem('userToken');
    var fname = sessionStorage.getItem('firstName');
    var lname = sessionStorage.getItem('lastName');
    var name = fname + " " + lname;
    var email = sessionStorage.getItem('email');
    var userType = sessionStorage.getItem("userType");

    const handleSendEmail = async (event) => {
        event.preventDefault();

        if (categoryType === "" || categoryType === undefined || bodyText === "" || bodyText === undefined) {
            Snackbar("emptyFields", 10000);
            return;
        }

        var regex = new RegExp(/^[a-zA-Z0-9!\-_()\'\":\.\?;@#,\t\n\r ]+$/gm);
        if (!regex.test(bodyText)) {
            Snackbar("msgSupportedChars", 10000);
            return;
        }

        var textarea = document.getElementById("contactMessageTextarea");
        textarea.value = '';
        textarea.style.height = '110px';

        document.getElementById("enrDropdown").selectedIndex = 0;

        await fetch("/sendContactEmail", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userID: keygenID, token: userToken, senderName: fname + " " + lname, senderEmail: email, message: bodyText.toString(), category: categoryType }),
        })
        .then(response => {
            if (response.json() === "Not Authorized") {
                sessionStorage.clear();
                navigate("/");
                return;
            }

            if (response.ok) {
                    document.getElementById("result-text").innerText = '';
                    Snackbar("emailSuccess", 10000);
                    setBodyText("");
                } else {
                    document.getElementById("result-text").innerText = "Hmm... something went wrong. Status: " + response.status + " " + response.statusText;
                }  
        })
        .catch(error => {
            console.log(error);
            document.getElementById("result-text").innerText = "An error has occured.";
            Snackbar("wentWrong", 10000);
        });
    }

    const handleRequestAdmin = async (event) => {
        event.preventDefault();
        if (!window.confirm("By continuing you are requesting that we consider your account for admin access.")) {
            return;
        }

        await fetch("/sendAdminRequestEmail", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userID: keygenID, token: userToken, senderName: name, senderEmail: email }),
        })
        .then(response => {
            if (response.json() === "Not Authorized") {
                sessionStorage.clear();
                navigate("/");
                return;
            }

            if (response.ok) {
                Snackbar("requestSuccess", 10000);
            } else {
                Snackbar("adminRequestFail", 10000);
                console.log("Admin request reponse: " + response.status + " " + response.statusText);
            } 
        })
        .catch(error => {
            console.log(error);
            Snackbar("wentWrong", 10000);
        });
    }
    
    return (
        <>
        <div>
            <TopNavBar></TopNavBar>
        </div>
        <div className="page" id="homePage">
            <div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>

            <br></br>
            <div className="snackbarNormal" id="emailSuccess">Success! Message sent.</div>
            <div className="snackbarYellow" id="emptyFields">Pick a category and share the details of your issue in the message field to proceed.</div>
            <div className="snackbarYellow" id="msgSupportedChars">Include only the following supported characters in your message: a-z, A-Z, 0-9, !, ?, ., -, _, (, ), ', ", :, ;, @, #, and spaces.</div>
            <div className="snackbarNormal" id="requestSuccess">Your request has been sent!</div>
            <div className="snackbarRed" id="adminRequestFail">Something went wrong when attempting to make your request</div>
            <div className="snackbarRed" id="wentWrong">Something went wrong. Please try again or contact us for help.</div>

            <div style={(userType === "Scientist" || userType === "Student") ? {display:'block', width:'1120px', fontSize:'14px'} : {display:'none'}} className="joinClassDiv">
                <div style={{width:'750px', height:'50px', marginLeft:'0px', marginTop:'7px', flexShrink:'0', right:'0', textAlign:'left', display:'flex'}}>
                    <p>Can't find the features you need? Request a Teacher Admin account:</p>
                    <div style={{width:'200px', height:'50px', marginLeft:'15px'}}>
                        <button className="btn" onClick={(e) => handleRequestAdmin(e)}>Request Admin Account</button>
                    </div>
                </div>
            </div>

            <p style={{marginBottom:'15px', textAlign:'left', width:'fit-content', height:'fit-content'}}>First name: <div className="secText" style={{marginLeft:'10px', width:'fit-content', height:'fit-content', display:'inline'}}>{fname}</div></p>
            <p style={{marginBottom:'15px', textAlign:'left', width:'fit-content', height:'fit-content'}}>Last name: <div className="secText" style={{marginLeft:'10px', width:'fit-content', height:'fit-content', display:'inline'}}>{lname}</div></p>
            <p style={{marginBottom:'10px', textAlign:'left', width:'fit-content', height:'fit-content'}}>Email: <div className="secText" style={{marginLeft:'48px', width:'fit-content', height:'fit-content', display:'inline'}}>{email}</div></p>

            <div style={{display:'flex', alignItems:'flex-start', marginBottom:'5px'}}>
                <select id="enrDropdown" onChange={(e) => setCategoryType(e.target.value)} defaultValue={'DEFAULT'}>
                    <option key="Select" value="DEFAULT" disabled>Category</option>
                    <option key="login" value="Login issues">Login issues</option>
                    <option key="hardware" value="Hardware issues">Hardware issues</option>
                    <option key="servers" value="syGlass Servers">syGlass Servers</option>
                    <option key="narrations" value="Narrations">Narrations</option>
                    <option key="other" value="Other">Other</option>
                </select>
			</div>

            <div style={{width:'1120px'}}>
                <p style={{textAlign:"left", marginTop:'20px', fontSize:'14px', marginBottom:'5px'}}>Describe your issue in detail and include information necessary to complete your request. If you are a student, include your class and teacher's name.</p>
                <div style={{height:'200px', width:'558px'}}>
                    <div style={{height:'130px', width:'558px'}}>
                        <textarea name="message" className="contactTextarea" id="contactMessageTextarea" onChange={(event) => setBodyText(event.target.value)} style={{width:'538px', height:'110px', padding:'10px'}} placeholder="Tell us what's going on..." required></textarea>
                    </div>
                </div>

                <div style={{width:'90px', hieght:'33px', marginTop:'16px'}}>
                    <button className='btn' onClick={handleSendEmail}>Send</button>
                </div>
        
                <p className="errorMessage" id="result-text"></p>
            </div>
        </div>
        </>
    )
}

export default ContactPage;